<!--
 * @Author: your name
 * @Date: 2020-11-05 11:18:16
 * @LastEditTime: 2021-06-09 16:10:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\list.vue
-->
<template>
 <div class="type-page">
     <img src="./../../assets/image/atte.jpg" />
     <div class="auth_info">
         <h1>认证介绍 <br /><span>Certification is introduced</span></h1>
         <p >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人工智能职业技能等级认证（AIOC）项目是由中国人工智能学会（CAAI）主办，旨在为全国热爱人工智能技术并立志于投身人工智能产业工作的人员提供的学习与认证服务。认证者通过官方指定的学习平台（www.91aioc.com）线上学习与实训、在线认证测试，考试合格后获得由中国人工智能学会颁发的人工智能职业技能等级认证证书，并通过中国人工智能学会官方查询入口（http://zscx.caai.cn/）在线查询。</p>
         <el-button @click="$router.push('./trainPosition')">查看认证岗位</el-button>   
     </div>
 </div>
</template>

<script>
export default {
    props: ['certList'],
    data(){
        return {
        }
    },
    methods: {
        jumpDetail(id){
            this.$router.push({
                path:'/trainDetail',
                query:{
                    newId:id
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.type-page {
    position: relative;
    min-height: 367px;
    background: url(./../../assets/image/Authentication_bg.png)0 0  no-repeat;
    margin: 80px auto;
    padding: 24px;
    img {
        width:32% ;
        height: 256px;
        margin-right: 24px;
    }
    .auth_info {
        float: right;
        width: 65%;
        h1 {
            font-size: 18px;
            font-weight: bold;
            color: #2B2F37;
            margin: 24px 0;
            span {
                font-size: 14px;
                font-weight: 400;
                color: #999999;
            }
        }
        p {
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 19px;
        }
        .el-button {
            width: 120px;
            height: 48px;
            background: #4165FF;
            box-shadow: 0px 14px 24px 0px rgba(65, 101, 255, 0.32);
            color: #fff;
            position: absolute;
            bottom:107px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/index/certificate.vue